import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IAlert, IAlertOptions  } from '../interfaces/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  public alertData: BehaviorSubject<{ alert: IAlert, visible: boolean }>;
  private currentOnCloseCallback: (() => void) | undefined;

  constructor() {
    const initialStep: IAlert = {
        width: "35vw",
        draggable: false,
        resizable: false,
        iconColor: "green",
        icon: "bx bxs-info-circle",
        title: "Alerta",
        detail: "Mensaje de alerta",
    };
    this.alertData = new BehaviorSubject<{ alert: IAlert, visible: boolean }>({
      alert: initialStep,
      visible: false
    });
  }

  get init() {
    return this.alertData.asObservable();
  }

  show(alert: IAlert, options?: IAlertOptions) {
    this.currentOnCloseCallback = options?.onClose;
    this.alertData.next({ alert, visible: true });
  }

  close() {
    const currentAlert = this.alertData.value.alert;
    this.alertData.next({ alert: currentAlert, visible: false });
    if (this.currentOnCloseCallback) {
      this.currentOnCloseCallback();
      this.currentOnCloseCallback = undefined;
    }
  }
}